CloverRespins = {};

CloverRespins.spineContainer = null;
CloverRespins.starterAnims = [];
CloverRespins.cloverCoinReveals = [];
CloverRespins.cloverBlankReveals = [];
CloverRespins.cloverReelSpins = [];
CloverRespins.cloverBackingSpins = [];
CloverRespins.specialSymbols = [12, 14, 15, 16, 17, 18, 19];
CloverRespins.respinData = undefined;
CloverRespins.cloverStopSoundIndex = 0;
CloverRespins.introSplashAnimating = false;
CloverRespins.currentSpin = undefined;

CloverRespins.create = function (json) {
  return new PIXI.Container();
};

CloverRespins.onGameConfig = function () {};

CloverRespins.getFilesRequired = function (json) {
  return [];
};

CloverRespins.initialise = function () {
  CloverRespins.completed = false;
  CloverRespins.spineContainer = resourceManager.get("postReels:spinsIntroContainer:spineContainer");

  CloverRespins.inProgress = false;

  CloverRespins.introSpineAnim = resourceManager.createObject(
    "spine",
    "cloverRespinsIntroSpine",
    CloverRespins.spineContainer,
    {
      name: "rapidRespinIntro",
      defaultAnimation: "animation",
    }
  );

  CloverRespins.introSpineAnim.visible = false;

  CloverRespins.stakeController = resourceManager.getController("stakeController");
};

CloverRespins.start = async function () {
  CloverRespins.completed = false;
  CloverRespins.inProgress = true;
  CloverRespins.currentSpin = CloverRespins.respinData.numberOfRespinsAwarded;
  CloverRespins.dimAllSymbols(true);
  soundManager.play("cloverSpinsStart");
  soundManager.play("cloverReelSpin");
  //Lock in current coins.
  gameController.lockCoins();
  gameController.canSkipWin = false;
  gameController.coinsCurrentlySkippable = false;

  await timerManager.delayAsync(1000);
  CloverRespins.introSplashAnimating = false;
  CloverRespins.createCloverAnims();
  CloverRespins.startCloverSpins();
};

CloverRespins.createCloverAnims = function () {
  let blankSymbols = CloverRespins.getBlankSymbols();
  blankSymbols.forEach(function (symbol) {
    CloverRespins.createIndividualAnims(symbol.reel, symbol.row);
    CloverRespins.hideSymbol(symbol);
  });
};

CloverRespins.getBlankSymbols = function () {
  let symbols = [];
  for (let i = 1; i < 4; ++i) {
    let reelVisual = resourceManager.get("slotContainer:reelContainer:reel" + i);
    for (let j = 0; j < reelVisual.appertureHeight; ++j) {
      if (!CloverRespins.coinOnSymbol(i, j)) {
        symbols.push({ reel: i, row: j });
      }
    }
  }
  return symbols;
};

CloverRespins.createIndividualAnims = function (reel, row) {
  const height = resourceManager.get(`slotContainer:reelContainer:reel${reel}:symbol0`).height;
  const width = resourceManager.get(`slotContainer:reelContainer:reel${reel}:symbol0`).width;
  const spinScale = CloverRespins.calculateSpinScale(reel);

  const reelVisual = resourceManager.get("slotContainer:reelContainer:reel" + reel);
  const symbolSize = reelVisual.appertureHeight;
  const yOffset = symbolSize === 3 ? 10 : 5;

  let cloverReelSpin = resourceManager.createObject(
    "movie",
    `cloverReelSpin:reel${reel}:symbol${row}`,
    `slotContainer:reelContainer:reel${reel}`,
    {
      definition: "goldSpinsReelSpin",
      x: -15,
      y: row * height - yOffset,
      scaleY: spinScale,
      loop: true,
    }
  );

  const revealDefinition = symbolSize < 5 ? "cloverRevealLong" : "cloverReveal";

  const revealPositioning = CloverRespins.calculateRevealPositioning(reel);
  const yPos = row * height + height / 2;

  let cloverReveal = resourceManager.createObject(
    "movie",
    `cloverReveal:reel${reel}:symbol${row}`,
    `slotContainer:reelContainer:reel${reel}`,
    {
      definition: revealDefinition,
      x: width / 2,
      y: yPos - revealPositioning.yOffset,
      scaleY: revealPositioning.scale,
      anchor: 0.5,
      loop: false,
    }
  );
  cloverReveal.visible = false;
  cloverReveal.onComplete = function () {
    cloverReveal.visible = false;
  };

  let cloverStart = resourceManager.createObject(
    "movie",
    `cloverStart:reel${reel}:symbol${row}`,
    `slotContainer:reelContainer:reel${reel}`,
    {
      definition: revealDefinition,
      x: width / 2,
      y: yPos - revealPositioning.yOffset,
      scaleY: revealPositioning.scale,
      anchor: 0.5,
      loop: false,
    }
  );
  cloverStart.visible = false;
  cloverStart.onComplete = function () {
    cloverStart.visible = false;
  };

  let cloverBlankReveal = resourceManager.createObject(
    "movie",
    `cloverBlankReveal:reel${reel}:symbol${row}`,
    `slotContainer:reelContainer:reel${reel}`,
    {
      definition: "cloverBlankReveal",
      x: width / 2,
      y: yPos - revealPositioning.yOffset,
      scaleY: revealPositioning.scale,
      anchor: 0.5,
      loop: false,
    }
  );
  cloverBlankReveal.visible = false;
  cloverBlankReveal.onComplete = function () {
    cloverBlankReveal.visible = false;
  };

  CloverRespins.starterAnims.push(cloverStart);
  CloverRespins.cloverReelSpins.push(cloverReelSpin);
  CloverRespins.cloverCoinReveals.push(cloverReveal);
  CloverRespins.cloverBlankReveals.push(cloverBlankReveal);
};

CloverRespins.hideSymbol = function (symbol) {
  gameData.reels[symbol.reel].showSymbol(symbol.row, false);
};

CloverRespins.startCloverSpins = function () {
  CloverRespins.scaleCounter(gameController.updateCounters.bind(this));
  CloverRespins.starterAnims.forEach((anim) => {
    anim.visible = true;
    anim.gotoAndStop(0);
    anim.play();
  });
  CloverRespins.stopCloverSpins();
};

CloverRespins.showIntro = function (cb) {
  return new Promise((res) => {
    gameController.dimAllSymbols(true);
    CloverRespins.introSplashAnimating = true;

    CloverRespins.introSpineAnim.scale.set(1);

    soundManager.play("cloverIntro");
    soundManager.play("cloverIntroText");
    musicManager.playCloverRespins();
    CloverRespins.introSpineAnim.visible = true;
    CloverRespins.introSpineAnim.play("animation", false, 0, () => {
      gsap.to(CloverRespins.introSpineAnim.scale, {
        duration: 0.7,
        ease: "linear",
        x: 0,
        y: 0,
        onComplete: () => {
          CloverRespins.introSpineAnim.visible = false;
          gameController.dimAllSymbols(false);
          res();
          if (cb) {
            cb();
          }
        },
      });
    });
  });
};

CloverRespins.stopCloverSpins = async function () {
  const data = CloverRespins.respinData;
  CloverRespins.currentSpin--;
  for (let i = 0; i < data.respins.length; i++) {
    let newCoins = [...data.respins[i].newCoins];
    let blanks = [...data.respins[i].blanks];
    let totalReveals = newCoins.length + blanks.length;

    await CloverRespins.revealResults(newCoins, blanks, totalReveals);
    await timerManager.delayAsync(2000);

    if (i !== data.respins.length - 1) {
      CloverRespins.resumeSpins(data.respins[i].blanks);
    }
  }

  CloverRespins.removeAllAnims();
  CloverRespins.dimAllSymbols(false);
  gameController.cloverRespinsComplete = true;
  gameController.arrCount = 0;
  PrizePots.onCompleteCallback = CloverRespins.onComplete.bind(this);
  PrizePots.awardPrizePot(true);
};

CloverRespins.onComplete = async function () {
  soundManager.stop("cloverReelSpin");
  let stakeController = resourceManager.getController("stakeController");
  //CoinsView.pulseAllCoins(false);
  await timerManager.delayAsync(1500);
  CloverRespins.currentSpin = undefined;
  CloverRespins.completed = true;
  CloverRespins.inProgress = false;
  gameController.clearLockedCoins();
  gameController.updateCounterState(gameController.globalHelperGetCurrentModeStake());
  gameController.canSkipWin = true;
  gameController.coinsCurrentlySkippable = true;
  CoinCollectionController.doCollection();
  //CoinsView.animateCashCoins();
};

CloverRespins.removeAllAnims = function () {
  CloverRespins.starterAnims.forEach((anim) => {
    resourceManager.destroyObject(anim.name);
  });
  while (CloverRespins.starterAnims.length) {
    CloverRespins.starterAnims.shift();
  }
  CloverRespins.cloverCoinReveals.forEach((anim) => {
    resourceManager.destroyObject(anim.name);
  });
  while (CloverRespins.cloverCoinReveals.length) {
    CloverRespins.cloverCoinReveals.shift();
  }
  CloverRespins.cloverBlankReveals.forEach((anim) => {
    resourceManager.destroyObject(anim.name);
  });
  while (CloverRespins.cloverBlankReveals.length) {
    CloverRespins.cloverBlankReveals.shift();
  }
  CloverRespins.cloverReelSpins.forEach((anim) => {
    resourceManager.destroyObject(anim.name);
  });
  while (CloverRespins.cloverReelSpins.length) {
    CloverRespins.cloverReelSpins.shift();
  }
};

CloverRespins.lockCoin = function (coin) {
  const coinPositioning = gameController.calculateCoinLockScale(coin.coord.reel);

  const coinLock = resourceManager.createObject(
    "movie",
    `lockedCoins:reel${coin.coord.reel}:symbol${coin.coord.row}`,
    `slotContainer:reelContainer:reel${coin.coord.reel}`,
    {
      definition: "coinLock",
      x: 0,
      y: 0,
      loop: true,
      anchor: 0.5,
      scaleY: coinPositioning.scale,
      scaleX: 1,
    }
  );

  const symbol = resourceManager.get(`slotContainer:reelContainer:reel${coin.coord.reel}:symbol${coin.coord.row}`);
  const symbolPos = helper.getLocalFromGlobalPosition(symbol, coinLock);

  coinLock.x = symbolPos.x;
  coinLock.y = symbolPos.y - coinPositioning.yOffset;

  const pulseTween = gsap.fromTo(
    coinLock.scale,
    {
      x: 1,
      y: coinPositioning.scale,
    },
    {
      paused: true,
      delay: 0,
      duration: 0.5,
      x: 1.05,
      y: coinPositioning.scale * 1.05,
      yoyo: true,
      repeat: 1,
    }
  );
  pulseTween.time(0).restart(true);
  coinLock.gotoAndStop(0);
  coinLock.play();
  gameController.lockedCoins.push(coinLock);
};

CloverRespins.resumeSpins = function (blanks) {
  gameController.cloverSpinsCurrent--;
  CloverRespins.currentSpin--;
  CloverRespins.scaleCounter(gameController.updateCounters.bind(this));
  blanks.forEach((blank) => {
    gameData.reels[blank.coord.reel].showSymbol(blank.coord.row, false);

    let cloverReelSpin = resourceManager.get(
      `slotContainer:reelContainer:reel${blank.coord.reel}:cloverReelSpin:reel${blank.coord.reel}:symbol${blank.coord.row}`
    );
    cloverReelSpin.visible = true;
    cloverReelSpin.gotoAndStop(0);
    cloverReelSpin.play();
  });
};

CloverRespins.scaleCounter = function (cb) {
  let text = resourceManager.get("postReels:rapidRespinsContainer:rapidRespinsMeterCount");
  let scale = text.scale;
  gsap
    .timeline()
    .to(text.scale, {
      duration: 0.6,
      ease: "linear",
      x: scale._x * 1.3,
      y: scale._y * 1.3,
      onComplete: () => {
        if (cb) {
          cb();
        }
      },
    })
    .to(text.scale, {
      duration: 0.4,
      ease: "linear",
      x: scale._x,
      y: scale._y,
      onComplete: () => {},
    });
};

CloverRespins.pulseCounter = function (cb) {
  const text = resourceManager.get("postReels:rapidRespinsContainer:rapidRespinsMeterCount");
  //const coins = resourceManager.get("postReels:CoinCounterContainer:coinCollectMeterFont");
  const scale = text.scale;
  //const coinsScale = coins.scale;
  gsap
    .timeline()
    .to(text.scale, {
      duration: 0.2,
      ease: "linear",
      x: scale._x * 1.3,
      y: scale._y * 1.3,
      yoyo: true,
      repeat: 5,
      onComplete: () => {
        if (cb) {
          cb();
        }
      },
    })
    .to(text.scale, {
      duration: 0.4,
      ease: "linear",
      x: scale._x,
      y: scale._y,
      onComplete: () => {},
    });
  // gsap
  //   .timeline()
  //   .to(coins.scale, {
  //     duration: 0.2,
  //     ease: "linear",
  //     x: coinsScale._x * 1.3,
  //     y: coinsScale._y * 1.3,
  //     yoyo: true,
  //     repeat: 5,
  //     onComplete: () => {},
  //   })
  //   .to(coins.scale, {
  //     duration: 0.4,
  //     ease: "linear",
  //     x: coinsScale._x,
  //     y: coinsScale._y,
  //     onComplete: () => {},
  //   });
};

CloverRespins.revealResults = async function (newCoins, blanks, totalReveals) {
  for (let j = 0; j < totalReveals; j++) {
    await timerManager.delayAsync(400);
    let nextReveal = CloverRespins.getNextReveal(newCoins, blanks);
    CloverRespins.revealResult(nextReveal);
  }
};

CloverRespins.getNewCoinID = (amount, symbolSize) => {
  const fishSymbolThresholds = [
    { min: 0, max: 3, id: 0 },
    { min: 3, max: 4, id: 1 },
    { min: 5, max: 6, id: 2 },
    { min: 8, max: 10, id: 3 },
    { min: 15, max: 20, id: 4 },
    { min: 25, max: Infinity, id: 5 },
  ];

  const fishSymbolMapOffsetToID = {
    0: 100,
    1: 106,
    2: 112,
    3: 118,
    4: 124,
  };

  const amountAsMulti = amount / CloverRespins.stakeController.getBaseStake();

  const cashID = fishSymbolThresholds.find(
    (threshold) => amountAsMulti >= threshold.min && amountAsMulti <= threshold.max
  ).id;

  const newSymbolID = fishSymbolMapOffsetToID[symbolSize] + cashID;

  return newSymbolID;
};

CloverRespins.revealResult = async function (nextReveal) {
  let reel = nextReveal.coord.reel;
  let row = nextReveal.coord.row;
  let cloverReelSpin = resourceManager.get(
    `slotContainer:reelContainer:reel${reel}:cloverReelSpin:reel${reel}:symbol${row}`
  );
  // let reelSpinBackingAnim = resourceManager.get(
  //   `slotContainer:reelContainer:reel${reel}:cloverBackingSpin:reel${reel}:symbol${row}`
  // );
  let cloverReveal = resourceManager.get(
    `slotContainer:reelContainer:reel${reel}:cloverReveal:reel${reel}:symbol${row}`
  );
  let cloverBlankReveal = resourceManager.get(
    `slotContainer:reelContainer:reel${reel}:cloverBlankReveal:reel${reel}:symbol${row}`
  );
  let reelVisual = resourceManager.get("slotContainer:reelContainer:reel" + reel);
  let symbolSize = reelVisual.appertureHeight - 3;

  CloverRespins.fadeOutAnim(cloverReelSpin);
  //CloverRespins.fadeOutAnim(reelSpinBackingAnim);

  if (nextReveal.type === "Cash") {
    cloverReveal.visible = true;
    cloverReveal.onComplete = () => {
      cloverReveal.visible = false;
      gameController.slotMachine.dimSymbol(reel, row, false, 0.1);
      CloverRespins.lockCoin(nextReveal);
    };
    cloverReveal.gotoAndStop(0);
    cloverReveal.play();

    timerManager.delayAsync(500, null, () => {
      const coinIndex = CloverRespins.getNewCoinID(nextReveal.amount, symbolSize);
      gameController.coins.push(nextReveal);
      CloverRespins.updateSymbolOnReel(reel, row, coinIndex);
      gameData.reels[reel].setReelSymbol(row, coinIndex);
      gameData.reels[reel].showSymbol(row, true);

      soundManager.play("coinLand");
    });
  } else if (nextReveal.type === "Bonus") {
    const bonusIndex = gameController.bonusID + 20 * symbolSize;
    gameController.coins.push(nextReveal);
    CloverRespins.updateSymbolOnReel(reel, row, bonusIndex);
    gameData.reels[reel].setReelSymbol(row, bonusIndex);
    gameData.reels[reel].showSymbol(row, true);

    timerManager.delayAsync(500, null, () => {
      const bonusIndex = gameController.bonusID + 20 * symbolSize;
      gameController.coins.push(nextReveal);
      CloverRespins.updateSymbolOnReel(reel, row, bonusIndex);
      gameData.reels[reel].setReelSymbol(row, bonusIndex);
      gameData.reels[reel].showSymbol(row, true);

      soundManager.play("bonusLand");
    });

    cloverReveal.visible = true;
    cloverReveal.onComplete = () => {
      cloverReveal.visible = false;
      gameController.slotMachine.dimSymbol(reel, row, false, 0.1);
      CloverRespins.lockCoin(nextReveal);
    };
    cloverReveal.gotoAndStop(0);
    cloverReveal.play();
  } else if (nextReveal.type === "Pot") {
    timerManager.delayAsync(500, null, () => {
      const potIndex = gameController.potID + 20 * symbolSize;
      gameController.coins.push(nextReveal);
      CloverRespins.updateSymbolOnReel(reel, row, potIndex);
      gameData.reels[reel].setReelSymbol(row, potIndex);
      gameData.reels[reel].showSymbol(row, true);

      soundManager.play("horseshoeLand");
    });

    cloverReveal.visible = true;
    cloverReveal.onComplete = () => {
      cloverReveal.visible = false;
      gameController.slotMachine.dimSymbol(reel, row, false, 0.1);
      CloverRespins.lockCoin(nextReveal);
    };
    cloverReveal.gotoAndStop(0);
    cloverReveal.play();
  } else {
    const index = nextReveal.symbol + 20 * symbolSize;
    let stopCount = CloverRespins.getStopSoundIndex();
    soundManager.play(`cloverReelStop${stopCount}`);

    gameData.reels[reel].setReelSymbol(row, index);
    gameData.reels[reel].showSymbol(row, true);

    cloverBlankReveal.visible = true;
    cloverBlankReveal.onComplete = () => {
      cloverBlankReveal.visible = false;
    };
    cloverBlankReveal.gotoAndStop(0);
    cloverBlankReveal.play();
  }
};

CloverRespins.getStopSoundIndex = function () {
  let newNumber;
  do {
    newNumber = Math.floor(Math.random() * 4);
  } while (newNumber === CloverRespins.cloverStopSoundIndex);

  CloverRespins.cloverStopSoundIndex = newNumber;
  return newNumber;
};

CloverRespins.updateSymbolOnReel = function (reel, row, newID) {
  for (let i = 0; i < gameController.symbolMap.length; i++) {
    const symbol = gameController.symbolMap[i];
    if (symbol.cell.reel === reel && symbol.cell.row === row) {
      symbol.symbolId = newID;
    }
  }
};

CloverRespins.fadeOutAnim = function (anim) {
  let fadeTween = gsap.fromTo(
    anim,
    {
      visible: true,
      alpha: 1,
    },
    {
      duration: 0.5,
      alpha: 0,
      onComplete: () => {
        anim.stop();
        anim.visible = false;
        anim.alpha = 1;
      },
    }
  );
  fadeTween.time(0).restart(true);
};

CloverRespins.dimAllSymbols = function (dim) {
  for (let reel = 0; reel < gameData.reels.length; reel++) {
    for (let row = 0; row < gameData.reels[reel].appertureHeight + 1; row++) {
      let symID = gameController.slotMachine.getSymbolId(reel, row);
      if (!CloverRespins.specialSymbols.includes(symID % 20) && symID < 100) {
        gameController.slotMachine.dimSymbol(reel, row, dim, 0.1);
      }
    }
  }
};

CloverRespins.getNextReveal = function (newCoins, blanks) {
  if (newCoins.length === 0) {
    return blanks.shift();
  }
  if (blanks.length === 0) {
    return newCoins.shift();
  }
  if (newCoins[0].coord.reel < blanks[0].coord.reel) {
    return newCoins.shift();
  } else if (newCoins[0].coord.reel > blanks[0].coord.reel) {
    return blanks.shift();
  } else {
    if (newCoins[0].coord.row < blanks[0].coord.row) {
      return newCoins.shift();
    } else if (newCoins[0].coord.row > blanks[0].coord.row) {
      return blanks.shift();
    }
  }
};

CloverRespins.calculateScale = function (reel) {
  let reelVisual = resourceManager.get("slotContainer:reelContainer:reel" + reel);
  let appertureHeight = reelVisual.appertureHeight;
  switch (appertureHeight) {
    case 3:
      return 1.65;
    case 4:
      return 1;
    case 5:
      return 0.85;
    case 6:
      return 0.75;
    case 7:
      return 0.65;
  }
};

CloverRespins.calculateSpinScale = function (reel) {
  let reelVisual = resourceManager.get("slotContainer:reelContainer:reel" + reel);
  let appertureHeight = reelVisual.appertureHeight;
  switch (appertureHeight) {
    case 3:
      return 1.6;
    case 4:
      return 1.2;
    case 5:
      return 1;
    case 6:
      return 0.8;
    case 7:
      return 0.7;
  }
};

CloverRespins.calculateRevealPositioning = function (reel) {
  let reelVisual = resourceManager.get("slotContainer:reelContainer:reel" + reel);
  let appertureHeight = reelVisual.appertureHeight;
  switch (appertureHeight) {
    case 3:
      return { scale: 1, yOffset: 30 };
    case 4:
      return { scale: 0.75, yOffset: 30 };
    case 5:
      return { scale: 0.9, yOffset: 25 };
    case 6:
      return { scale: 0.8, yOffset: 20 };
    case 7:
      return { scale: 0.7, yOffset: 15 };
  }
};

CloverRespins.coinOnSymbol = function (reel, row) {
  return gameController.coins.some((coin) => coin.coord.reel === reel && coin.coord.row === row);
};

resourceManager.registerObjectType(
  "CloverRespins",
  CloverRespins.create,
  CloverRespins.initialise,
  CloverRespins.getFilesRequired
);
